import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import zestLogo from "@assets/image/zestLogo.png";
import { PrimaryText } from "@components";
import { getMenus } from "@store";
import "../containerStyle.css";

function Footer() {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const footerMenu = useSelector((state) => state.menu.menus);

  useEffect(() => {
    dispatch(getMenus());
  }, []);

  const goPage = (e) => {
    navigate(e?.contant?.attributes?.url);
  };

  const FooterTxt = (props) => {
    return (
      <button onClick={() => goPage(props)}>
        <PrimaryText className={`${footerText} footer-underline-animation`}>
          {props.children}
        </PrimaryText>
      </button>
    );
  };

  return (
    <div>
      <Line></Line>
      {footerMenu && (
        <Container>
          <div className="xl:w-[230px] w-auto h-[10px]"></div>
          <div>
            {footerMenu?.map((item, index) => (
              <React.Fragment key={`footer${index}`}>
                {item?.attributes?.slug !== "header" && (
                  <FooterView>
                    {item?.attributes?.items?.data?.map((items, index2) => (
                      <React.Fragment key={`footer${index2}`}>
                        <FooterTxt contant={items}>
                          {items?.attributes?.title}
                        </FooterTxt>
                      </React.Fragment>
                    ))}
                  </FooterView>
                )}
              </React.Fragment>
            ))}

            <SocialView>
              <SocialLogo
                target="_blank"
                href="https://www.facebook.com/thekclub/"
              >
                <FacebookIcon fontSize="large" sx={{ color: "white" }} />
              </SocialLogo>
              <SocialLogo target="_blank" href="https://twitter.com/thekclub">
                <TwitterIcon fontSize="large" sx={{ color: "white" }} />
              </SocialLogo>
              <SocialLogo
                target="_blank"
                href="https://www.instagram.com/thekclubireland/"
              >
                <InstagramIcon fontSize="large" sx={{ color: "white" }} />
              </SocialLogo>
            </SocialView>
          </div>

          <PoweredBy>
            <PrimaryText className={copyTxt}>
              {t("footer.poweredBy")}{" "}
            </PrimaryText>
            <img
              src={zestLogo}
              className="w-[130px] h-auto drop-shadow-[0px_1px_1px_rgba(0,0,0,0.6)]"
              alt="img"
            />
          </PoweredBy>
        </Container>
      )}
    </div>
  );
}

const Container = tw.div`
w-full 
h-auto 
flex 
xl:flex-row flex-col 
xl:items-start
justify-between
`;
const Line = tw.div`
w-full 
h-[1.2px] 
bg-gold
mt-[10px]
`;
const FooterView = tw.div`
w-auto 
h-auto 
flex 
flex-wrap 
items-center 
xl:justify-center justify-start 
xl:px-[5px] px-6
py-6 
gap-x-8 
gap-y-4
`;
const footerText = `
text-[1.075rem] 
text-white255 
font-semibold 
font-[Cambay] 
`;
const copyTxt = `
text-[0.975rem]
opacity-70
font-[Cambay]
text-left
text-white255
`;
const SocialView = tw.div`
w-full 
h-auto 
flex 
flex-wrap 
items-center 
xl:justify-center justify-start 
px-6
xl:pb-12 pb-2 
gap-x-8 
gap-y-4
`;
const SocialLogo = tw.a`
duration-500 
hover:transform 
hover:scale-125
`;
const PoweredBy = tw.div`
w-auto 
h-auto 
flex 
flex-row 
gap-2 
items-center 
justify-end 
py-2
lg2:pl-[0px] pl-4
pr-[6px]
mt-4
`;

export default Footer;
